module.exports = __webpack_public_path__ + "img/service-03.12d2d7e7.webp";